import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AccountingActionCreators from 'actions/AccountingActionCreators';
import InvoiceStore from 'stores/accounting/InvoiceStore';
import SessionStore from 'stores/SessionStore';
import AccountingWebAPIUtils, { setInvoicePaymentMethod, } from 'utils/AccountingWebAPIUtils';
import { getShipmentByOid, downloadPODs } from 'utils/ShipmentWebAPIUtils';
import { fetchSignedUrlByForeignKey } from 'utils/DocumentsAPIUtils';
import ShipmentSearch from 'components/site/shipment-search';
import _ from 'underscore';
import Spinner from 'components/ui/Spinner';
import DataPoller from 'components/ui/DataPoller';
import InvoiceJobList from './v2/InvoiceJobList';
import InvoiceHeader from './v2/InvoiceHeader';
import { paymentMethods } from 'constants/accounting';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import Alert from 'components/ui/Alert';
import { showToast } from 'stores/ToastStore';
import { withTranslation } from 'react-i18next';
import { BadgeAlt as Badge, Button, Card, CardHeader, CardContent, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Tabs, TabsList, TabsTrigger, TabsContent, } from '@cargomatic/ui';
import { ChevronDown, DollarSign } from 'lucide-react';
import formatMoney from 'utils/formatters/Money';
import { isValidInvoiceForCreditMemo, transformPayload, transformRebillData, } from 'utils/credit-memo';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { sluggify } from '../../../../utils/localization/utils';
import CreditMemoModal from 'components/modules/shipments/accounting/CreditMemoModal';
import { generateCreditMemo, getOrder } from 'utils/OrderWebAPIUtils';
import { get, cloneDeep } from 'lodash';
import PaymentSummary from '../payment-summary-v2';
import PaymentHistory from '../payment-history';
import LogPaymentModal from '../log-payment-modal';
import PaymentMethodDialog from '../PaymentMethodDialog';
import HistoryTable from '../history-table';
import CreditMemoTable from './credit-memo';
import InvoiceARTable from './v2/InvoiceARTable';
import SendEmailModal from '../send-email-modal';
import { isLegManagementEnabled } from 'helpers/legs-helper';
const STRIPE = 'automated';
const ACH = 'manual';
const Loading = () => {
    return (React.createElement("div", { "data-testid": "div-4b795707", className: "absolute justify-center w-full", style: { top: '50%' } },
        React.createElement("div", { "data-testid": "div-2f499e92", className: "align-middle" },
            React.createElement("span", { "data-testid": "span-694b47d2", className: "text-5xl text-green" },
                React.createElement(Spinner, { dataTestId: "Spinner-0fa95b56", showMessage: false })))));
};
function getStateFromStores(invoiceId) {
    const invoice = InvoiceStore.getInvoice(invoiceId);
    let balance = 0;
    if (invoice)
        balance = invoice.amount_due;
    return {
        invoice: invoice,
        balance: balance,
        loading: false,
        editMode: false,
        updates: [],
    };
}
const JOBLIST_ACTIONS = {
    ADD: 'add',
    REMOVE: 'remove',
};
class InvoiceDetails extends Component {
    constructor(props) {
        var _a, _b;
        super(props);
        this._onChangeInFlight = false;
        this.getShipmentData = async (oid) => {
            const { t } = this.props;
            this.setState({ loading: true });
            try {
                const result = await getShipmentByOid(oid);
                this.setState({ shipment: result });
            }
            catch (_a) {
                showToast(t('FAILED_TO_FETCH_SHIPMENT_DATA'), null, 'error');
                this.setState({ shipment: {} });
            }
            this.setState({ loading: false });
        };
        this.handleSaveCreditMemo = async (rebillData) => {
            var _a, _b, _c;
            const { t } = this.props;
            this.setState({ disableSaveCreditMemoButton: true });
            try {
                const { shipment, invoiceId, invoice } = this.state;
                const adjustedItems = ((_a = rebillData === null || rebillData === void 0 ? void 0 : rebillData.adjustedItems) !== null && _a !== void 0 ? _a : []).map((item) => {
                    var _a;
                    return Object.assign(Object.assign({}, item), { notes: ((_a = item.notes) !== null && _a !== void 0 ? _a : '').trim() });
                });
                const data = {
                    rebill: rebillData.rebill,
                    adjustedItems,
                };
                const selectedCharges = transformPayload(data, shipment, invoice);
                const rebillInformation = transformRebillData(data, shipment);
                const sendEdi = true;
                const invoiceCreatedDate = (invoice === null || invoice === void 0 ? void 0 : invoice.date_created) || new Date();
                const orderId = ((_b = shipment === null || shipment === void 0 ? void 0 : shipment.order) === null || _b === void 0 ? void 0 : _b._id) || (shipment === null || shipment === void 0 ? void 0 : shipment.order);
                const result = await generateCreditMemo(orderId, invoiceId, invoiceCreatedDate, rebillInformation, selectedCharges, data.rebill, sendEdi);
                this.setState({
                    showCreditMemoModal: false,
                    disableSaveCreditMemoButton: false,
                    disableCreditMemoOption: (_c = result === null || result === void 0 ? void 0 : result.entity) === null || _c === void 0 ? void 0 : _c.success,
                });
                showToast(t('CREDIT_MEMO_GENERATION_SUCCESS'));
            }
            catch (_d) {
                showToast(t('CREDIT_MEMO_GENERATION_FAILURE'), null, 'error');
                this.setState({
                    showCreditMemoModal: false,
                    disableSaveCreditMemoButton: false,
                });
            }
        };
        this.getSelectedLineItem = (invoice = {}) => {
            let selectedLineItem = {};
            if (invoice && Object.keys(invoice).length) {
                const selectedInvoice = { _id: invoice._id, number: invoice.number };
                if (get(invoice, 'lineItemGroups[0].lineItems[0]', false)) {
                    selectedLineItem = Object.assign(Object.assign({}, invoice.lineItemGroups[0].lineItems[0]), { invoice: selectedInvoice });
                    return selectedLineItem;
                }
                selectedLineItem = { invoice: selectedInvoice };
            }
            return selectedLineItem;
        };
        this.onChange = async () => {
            var _a, _b, _c;
            if (this._onChangeInFlight) {
                this._onChangePending = true;
                return;
            }
            this._onChangeInFlight = true;
            const result = getStateFromStores(this.state.invoiceId);
            try {
                const invoiceState = cloneDeep(result);
                if (invoiceState === null || invoiceState === void 0 ? void 0 : invoiceState.invoice) {
                    // Fetch the full order if it's not populated (just an ID string)
                    const { order } = invoiceState.invoice;
                    if (order && typeof order === 'string') {
                        // Reuse the already-fetched order if the ID matches
                        const cachedOrder = (_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.order;
                        if (cachedOrder &&
                            typeof cachedOrder === 'object' &&
                            (cachedOrder._id === order || cachedOrder.id === order)) {
                            invoiceState.invoice.order = cachedOrder;
                        }
                        else {
                            try {
                                const { entity } = await getOrder(order);
                                invoiceState.invoice.order = (entity === null || entity === void 0 ? void 0 : entity.order) || order;
                            }
                            catch (e) {
                                console.error('Error fetching order:', e);
                            }
                        }
                    }
                    if (((_c = (_b = invoiceState.invoice) === null || _b === void 0 ? void 0 : _b.jobs) === null || _c === void 0 ? void 0 : _c.length) &&
                        !Object.keys(this.state.shipment).length) {
                        await this.getShipmentData(invoiceState.invoice.jobs[0]);
                    }
                    this.setState(Object.assign(Object.assign({}, invoiceState), { regenerating: false }));
                }
            }
            catch (e) {
                showToast(e === null || e === void 0 ? void 0 : e.message, null, 'error');
            }
            finally {
                this._onChangeInFlight = false;
                if (this._onChangePending) {
                    this._onChangePending = false;
                    this.onChange();
                }
            }
        };
        this.checkPricingManagerPermission = () => {
            const { t } = this.props;
            if (!this.state.isFinanceAdmin) {
                showToast(t('PERMISSION_REQUIRED'), t('PERMISSION_REQUIRED'), 'error');
                return false;
            }
            return true;
        };
        this.savePayment = (payment) => {
            AccountingActionCreators.recordPaymentForInvoice(this.state.invoiceId, payment);
        };
        this.handleInvoiceRegenerateUpdate = () => {
            if (!InvoiceStore.getInvoiceRegenerationStatus()) {
                const invoice = InvoiceStore.getUpdatedInvoice();
                this.setState({
                    regenerating: false,
                    invoice: invoice !== null && invoice !== void 0 ? invoice : this.state.invoice,
                });
            }
        };
        this.regenerateInvoice = (_id, type, data) => {
            this.setState({ regenerating: true }, () => AccountingWebAPIUtils.regenerateInvoice(_id, type, data));
        };
        this.handlePaymentMethodSelect = async (value) => {
            var _a;
            if (!value) {
                return;
            }
            const method = value.toLowerCase();
            const currentMethod = this.state.paymentMethod || ((_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.payment_method);
            if (method && method !== currentMethod) {
                const previousMethod = currentMethod || null;
                const method_value = method === 'manual' ? 'manual' : 'automated';
                try {
                    await setInvoicePaymentMethod(method_value, this.state.invoiceId);
                    this.setState({ paymentMethod: method });
                    showToast('Payment method updated', null, 'success');
                }
                catch (e) {
                    console.error(e);
                    this.setState({ paymentMethod: previousMethod });
                    showToast('Failed to update payment method', null, 'error');
                }
            }
        };
        this.handleSavePaymentMethod = async () => {
            const { tempPaymentMethod } = this.state;
            if (tempPaymentMethod) {
                this.setState({ isSavingPaymentMethod: true });
                try {
                    await this.handlePaymentMethodSelect(tempPaymentMethod);
                    this.setState({ showPaymentMethodDialog: false });
                }
                finally {
                    this.setState({ isSavingPaymentMethod: false });
                }
            }
            else {
                this.setState({ showPaymentMethodDialog: false });
            }
        };
        this.handleJobRemove = async (invoice, lineItem) => {
            var _a;
            try {
                const updatedJobIds = ((_a = invoice.jobs) !== null && _a !== void 0 ? _a : []).filter((id) => (typeof id === 'string' ? id : id === null || id === void 0 ? void 0 : id._id) !== lineItem.shipment_id);
                this.setState({ showLineItemConfirmModal: false });
                const newInvoice = await AccountingWebAPIUtils.updateInvoiceJobs(invoice, updatedJobIds, JOBLIST_ACTIONS.REMOVE);
                this.setState({
                    invoice: newInvoice,
                    confirmModal: this.confirmModalDefault(),
                });
            }
            catch (e) {
                showToast(e === null || e === void 0 ? void 0 : e.message, null, 'error');
            }
        };
        this.handleSearch = (invoice, value, job) => {
            var _a, _b;
            if (!this.checkPricingManagerPermission())
                return;
            const originalGroups = (_b = (_a = this.state.originalLineItemGroups) !== null && _a !== void 0 ? _a : invoice.lineItemGroups) !== null && _b !== void 0 ? _b : [];
            const searchedShipmentId = job.shipmentId;
            const listOfJobs = originalGroups.filter((jobsAssociated) => jobsAssociated.shipmentId === searchedShipmentId);
            if (listOfJobs.length) {
                this.setState({
                    selectedValue: value,
                    originalLineItemGroups: originalGroups,
                    invoice: Object.assign(Object.assign({}, invoice), { lineItemGroups: listOfJobs }),
                });
            }
            else {
                this.setState({ selectedValue: value });
            }
        };
        this.onSelectChange = (value) => {
            var _a, _b, _c;
            const invoiceState = getStateFromStores(this.state.invoiceId);
            const { selectedValue, originalLineItemGroups } = this.state;
            const lineItemGroups = (_b = originalLineItemGroups !== null && originalLineItemGroups !== void 0 ? originalLineItemGroups : (_a = invoiceState.invoice) === null || _a === void 0 ? void 0 : _a.lineItemGroups) !== null && _b !== void 0 ? _b : [];
            value = value.trim().toUpperCase();
            if (value.length && value !== selectedValue) {
                const filteredJobs = lineItemGroups.filter((lineItemGroup) => { var _a; return (_a = lineItemGroup.shipmentId) === null || _a === void 0 ? void 0 : _a.includes(value); });
                this.setState({
                    invoice: Object.assign(Object.assign({}, invoiceState.invoice), { lineItemGroups: filteredJobs }),
                });
            }
            else {
                this.setState({
                    invoice: (_c = invoiceState.invoice) !== null && _c !== void 0 ? _c : this.state.invoice,
                    originalLineItemGroups: null,
                    selectedValue: '',
                });
            }
        };
        this.setChanges = (updates) => {
            const { editMode } = this.state;
            this.setState({ updates });
            if (!editMode) {
                this.setState({ editMode: true });
            }
        };
        this.confirmModalDefault = () => {
            return {
                title: '',
                message: '',
                onConfirm: null,
            };
        };
        this.confirmRemoveShipment = (job) => {
            if (!this.checkPricingManagerPermission())
                return;
            const { t } = this.props;
            const title = t('REMOVE_SHIPMENT_FROM_INVOICE_TITLE', {
                shipment_id: job.shipmentId,
            });
            const message = t('REMOVE_SHIPMENT_FROM_INVOICE_MESSAGE');
            this.setState((prevState) => ({
                showLineItemConfirmModal: true,
                confirmModal: {
                    title,
                    message,
                    onConfirm: () => this.handleJobRemove(prevState.invoice, job),
                },
            }));
        };
        this.isDebitInvoiceType = () => {
            var _a, _b;
            return (!((_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.invoice_type) ||
                ((_b = this.state.invoice) === null || _b === void 0 ? void 0 : _b.invoice_type) === 'debit');
        };
        this.openCreditMemoModal = () => {
            if (this.state.canGenerateCreditMemo) {
                this.setState({ showCreditMemoModal: true });
            }
        };
        this.sendEmail = (emails) => {
            const { invoice, invoiceId } = this.state;
            const invoice_type = (invoice === null || invoice === void 0 ? void 0 : invoice.invoice_type) || 'debit';
            const isCreditMemo = invoice_type === 'credit';
            AccountingActionCreators.emailInvoice(invoiceId, emails, isCreditMemo);
        };
        this.sendEdiInvoice = async () => {
            var _a;
            const { t } = this.props;
            try {
                const response = await AccountingWebAPIUtils.sendEdiInvoice(this.state.invoice._id);
                if (response.entity && ((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.success)) {
                    AccountingActionCreators.getInvoice(this.state.invoice._id);
                }
                else {
                    showToast(t('EDI_SEND_FAILED'), null, 'error');
                }
            }
            catch (e) {
                showToast(e === null || e === void 0 ? void 0 : e.message, null, 'error');
            }
        };
        this.handlePODDownload = async () => {
            this.setState({ downloadingPods: true });
            try {
                await downloadPODs({ invoiceId: this.state.invoice._id });
            }
            catch (e) {
                showToast(e === null || e === void 0 ? void 0 : e.message, null, 'error');
            }
            this.setState({ downloadingPods: false });
        };
        this.handleDownload = async () => {
            const { t } = this.props;
            const newWindow = window.open('', '_blank');
            try {
                const { url, error } = await fetchSignedUrlByForeignKey(this.state.invoiceId);
                if (url) {
                    if (newWindow) {
                        newWindow.opener = null;
                        newWindow.location.href = url;
                    }
                }
                else {
                    newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                    showToast(t('GET_SIGNED_URL_ERROR'), error, 'error');
                }
            }
            catch (e) {
                newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                showToast(t('GET_SIGNED_URL_ERROR'), e.message, 'error');
            }
        };
        this.state = {
            loading: true,
            selectedValue: '',
            invoiceId: props.invoiceId || ((_b = (_a = props.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.id),
            isAdmin: SessionStore.isAdmin(),
            paymentMethod: null,
            showLineItemConfirmModal: false,
            isSavingPaymentMethod: false,
            showPaymentMethodDialog: false,
            tempPaymentMethod: null,
            activeTab: 'jobs',
            showLogPaymentModal: false,
            confirmModal: this.confirmModalDefault(),
            isFinanceAdmin: SessionStore.isFinanceAdmin(),
            hasFinanceAdminRole: SessionStore.hasFinanceAdminRole(),
            invoice: {},
            canGenerateCreditMemo: SessionStore.canGenerateCreditMemo(),
            showCreditMemoModal: false,
            disableSaveCreditMemoButton: false,
            shipment: {},
            selectedLineItem: {},
            disableCreditMemoOption: false,
            invoiceErrors: null,
            regenerating: false,
            showSendEmailModal: false,
            downloadingPods: false,
        };
    }
    async componentDidMount() {
        InvoiceStore.register(this.onChange);
        AccountingActionCreators.getInvoice(this.state.invoiceId, SessionStore.getUserType());
        InvoiceStore.addChangeListener(this.handleInvoiceRegenerateUpdate);
    }
    componentWillUnmount() {
        InvoiceStore.unregister(this.onChange);
        InvoiceStore.removeChangeListener(this.handleInvoiceRegenerateUpdate);
    }
    componentDidUpdate(prevProps) {
        if (this.props.invoiceId !== prevProps.invoiceId) {
            this.setState({
                invoiceId: this.props.invoiceId,
            });
            AccountingActionCreators.getInvoice(this.props.invoiceId, SessionStore.getUserType());
        }
    }
    getPaymentMethodLabel() {
        const { t } = this.props;
        const selectedValue = this.defineDropdownSelectedValue();
        const method = paymentMethods.find((m) => m.value === selectedValue);
        return method ? t(method.localizationSlug) : t('SELECT_PAYMENT_METHOD');
    }
    defineDropdownSelectedValue() {
        const { paymentMethod, invoice } = this.state;
        const payment_method = invoice === null || invoice === void 0 ? void 0 : invoice.payment_method;
        if (paymentMethod) {
            return paymentMethod === 'automated' ? STRIPE : ACH;
        }
        if (payment_method) {
            return payment_method === 'automated' ? STRIPE : ACH;
        }
        return '';
    }
    renderInvoiceV1() {
        var _a, _b, _c, _d, _e, _f, _g;
        const { t } = this.props;
        const { invoice, isAdmin, invoiceErrors, disableCreditMemoOption } = this.state;
        const { title, message, onConfirm } = this.state.confirmModal;
        const showInvoiceErrors = invoiceErrors && !_.isEmpty(invoiceErrors);
        const selectedValue = this.defineDropdownSelectedValue();
        const { _id, type, order } = invoice;
        const orderId = typeof order === 'string' ? order : ((_a = order === null || order === void 0 ? void 0 : order._id) !== null && _a !== void 0 ? _a : '');
        const date_created = (invoice === null || invoice === void 0 ? void 0 : invoice.date_created) || new Date();
        const isMultiJobInvoice = ((_b = invoice === null || invoice === void 0 ? void 0 : invoice.jobs) === null || _b === void 0 ? void 0 : _b.length) > 1;
        const disableCMBtn = ((invoice === null || invoice === void 0 ? void 0 : invoice.credit_memos) || []).length ||
            disableCreditMemoOption ||
            isMultiJobInvoice;
        return (React.createElement("div", { "data-testid": "div-f104d4f9", className: "mx-auto max-w-7xl space-y-6 p-4 sm:p-6 lg:p-8" },
            showInvoiceErrors && (React.createElement(Alert, { dataTestId: "Alert-4eedc2d6", type: "warning", title: invoiceErrors.title },
                React.createElement("div", { "data-testid": "div-57ba8b68" }, invoiceErrors.body))),
            React.createElement("div", { className: "flex flex-wrap items-center justify-between" },
                React.createElement("div", { className: "flex items-center space-x-3" },
                    React.createElement("h2", { "data-testid": "h2-0c2badfe", className: "my-0" }, invoice.number),
                    isAdmin && this.isDebitInvoiceType() && invoice.edi_sent && (React.createElement(Badge, { variant: "outline", "data-testid": "CargomaticBadge-c98247c2", className: "border-emerald-200 bg-emerald-50 text-emerald-700" }, t('EDI_SENT'))),
                    invoice.missing_pods != null && (React.createElement(Badge, { variant: "outline", "data-testid": "CargomaticBadge-pod-status", className: invoice.missing_pods
                            ? 'border-red-200 bg-red-50 text-red-700'
                            : 'border-emerald-200 bg-emerald-50 text-emerald-700' }, invoice.missing_pods
                        ? t('WITHOUT_PODS_JOBS')
                        : t('ALL_PODS_RECEIVED'))),
                    React.createElement(Badge, { variant: "outline", "data-testid": "CargomaticBadge-invoice-status", className: "border-gray-200 bg-gray-50 text-gray-700" }, t(sluggify(invoice.status)))),
                React.createElement("div", { className: "flex items-center gap-3" },
                    isAdmin && this.isDebitInvoiceType() && (React.createElement(PaymentMethodDialog, { open: this.state.showPaymentMethodDialog, onOpenChange: (open) => {
                            this.setState(Object.assign({ showPaymentMethodDialog: open }, (open ? { tempPaymentMethod: selectedValue } : {})));
                        }, selectedValue: selectedValue, tempValue: this.state.tempPaymentMethod, onTempValueChange: (value) => this.setState({ tempPaymentMethod: value }), onSave: this.handleSavePaymentMethod, isSaving: this.state.isSavingPaymentMethod, disabled: !this.state.hasFinanceAdminRole, label: this.getPaymentMethodLabel(), description: t('PAYMENT_METHOD_TOOLTIP_MESSAGE') })),
                    React.createElement(DropdownMenu, null,
                        React.createElement(DropdownMenuTrigger, { asChild: true },
                            React.createElement(Button, { variant: "outline", className: "gap-2" },
                                t('ACTIONS'),
                                React.createElement(ChevronDown, { className: "h-4 w-4" }))),
                        React.createElement(DropdownMenuContent, { align: "end" },
                            this.state.canGenerateCreditMemo &&
                                isValidInvoiceForCreditMemo(invoice) && (React.createElement(DropdownMenuItem, { className: "gap-2", disabled: !!disableCMBtn, onClick: disableCMBtn ? undefined : this.openCreditMemoModal }, t('CREATE_CREDIT_MEMO'))),
                            React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                                React.createElement(DropdownMenuItem, { className: "gap-2", onClick: () => this.setState({ showSendEmailModal: true }) }, t('EMAIL_INVOICE'))),
                            React.createElement(DropdownMenuItem, { className: "gap-2", onClick: this.handleDownload }, t('DOWNLOAD')),
                            this.isDebitInvoiceType() && (React.createElement(DropdownMenuItem, { className: "gap-2", disabled: this.state.downloadingPods, onClick: () => this.handlePODDownload() }, t('DOWNLOAD_PODS'))),
                            isAdmin && this.isDebitInvoiceType() && (React.createElement(DropdownMenuItem, { className: "gap-2", onClick: () => this.regenerateInvoice(_id, type, {
                                    orderId,
                                    invoiceDate: date_created,
                                }), disabled: this.state.regenerating }, t('REGENERATE_INVOICE'))),
                            isAdmin && this.isDebitInvoiceType() && !invoice.edi_sent && (React.createElement(DropdownMenuItem, { className: "gap-2", onClick: this.sendEdiInvoice }, t('SEND_EDI'))))))),
            React.createElement("div", { className: "flex w-full flex-col gap-4 lg:grid lg:grid-cols-4 lg:gap-4" },
                React.createElement("div", { className: "col-span-1" },
                    React.createElement(Card, null,
                        React.createElement(CardHeader, null,
                            React.createElement("h3", { className: "m-0 text-base font-semibold" }, t('SUMMARY'))),
                        React.createElement(CardContent, null, this.isDebitInvoiceType() ? (React.createElement(PaymentSummary, { total: invoice.total, paid: invoice.total_payments, balance: invoice.amount_due, credit_memos: invoice.credit_memos || [], currency: invoice === null || invoice === void 0 ? void 0 : invoice.currency })) : (React.createElement("div", { className: "grid grid-cols-2 gap-y-4 gap-x-2" },
                            React.createElement("div", null,
                                React.createElement("div", { className: "text-sm font-medium text-muted-foreground" }, t('CREDIT')),
                                React.createElement("div", { className: "text-red-500 font-medium" }, formatMoney(invoice.total, invoice === null || invoice === void 0 ? void 0 : invoice.currency))),
                            React.createElement("div", null,
                                React.createElement("div", { className: "text-sm font-medium text-muted-foreground" }, t('CREDITED_INVOICE')),
                                React.createElement("a", { "data-testid": "a-b0a4e65d", href: `/invoices/${(_c = invoice.original_invoice) === null || _c === void 0 ? void 0 : _c.id}`, target: "_blank", rel: "noreferrer" }, (_d = invoice.original_invoice) === null || _d === void 0 ? void 0 : _d.number))))))),
                this.isDebitInvoiceType() && (React.createElement("div", { className: "col-span-3 flex flex-col gap-4" },
                    React.createElement(Card, null,
                        React.createElement(CardHeader, null,
                            React.createElement("div", { className: "flex items-center justify-between" },
                                React.createElement("h3", { className: "my-0 text-base font-semibold" }, t('PAYMENTS')),
                                isAdmin && (React.createElement(Button, { size: "sm", className: "bg-zinc-900 text-white hover:bg-zinc-800 gap-2", "data-testid": "button-17f95155", onClick: () => this.setState({ showLogPaymentModal: true }) },
                                    React.createElement(DollarSign, { className: "h-4 w-4" }),
                                    t('RECORD_PAYMENT'))))),
                        React.createElement(CardContent, null,
                            React.createElement(PaymentHistory, { payments: ((_e = invoice.payments) === null || _e === void 0 ? void 0 : _e.filter((payment) => payment.type === 'payment')) || [], currency: invoice === null || invoice === void 0 ? void 0 : invoice.currency }))),
                    invoice.invoice_type !== 'credit' &&
                        ((_f = invoice.credit_memos) === null || _f === void 0 ? void 0 : _f.length) > 0 && (React.createElement(Card, null,
                        React.createElement(CardHeader, null,
                            React.createElement("h3", { className: "my-0 text-base font-semibold" }, t('CREDIT_MEMO', { count: 5 }))),
                        React.createElement(CardContent, null,
                            React.createElement(CreditMemoTable, { creditMemoList: invoice.credit_memos }))))))),
            React.createElement(Card, null,
                React.createElement(Tabs, { defaultValue: "jobs", className: "w-full", onValueChange: (value) => this.setState({ activeTab: value }) },
                    React.createElement(CardHeader, { className: "pb-3" },
                        React.createElement(TabsList, { className: "justify-start" },
                            React.createElement(TabsTrigger, { value: "jobs" }, t('LINE_ITEMS')),
                            React.createElement(TabsTrigger, { value: "audit" }, t('AUDIT_HISTORY')))),
                    React.createElement(TabsContent, { value: "jobs", className: "mt-0" },
                        React.createElement("div", { className: "px-6 pb-4" },
                            React.createElement("div", { className: "w-full sm:w-80" },
                                React.createElement(ShipmentSearch, { isFilter: true, lineItemGroups: (_g = invoice.lineItemGroups) !== null && _g !== void 0 ? _g : [], dataTestId: "ShipmentSearch-ja42ew24", onSelect: (value, job) => {
                                        this.handleSearch(invoice, value, job);
                                    }, onChange: (value) => this.onSelectChange(value), disabled: !this.state.isFinanceAdmin }))),
                        React.createElement(CardContent, { className: "overflow-x-auto" },
                            React.createElement(InvoiceJobList, { invoice: invoice }))),
                    React.createElement(TabsContent, { value: "audit", className: "mt-0" },
                        React.createElement(CardContent, null,
                            React.createElement(HistoryTable, { data: invoice.audit || [], type: "Invoice" }))))),
            React.createElement(DataPoller, { dataTestId: "DataPoller-32de1597", frequency: 60000, action: () => this.onChange() }),
            this.state.showLogPaymentModal && (React.createElement(LogPaymentModal, { show: this.state.showLogPaymentModal, amount: (this.state.balance || 0).toFixed(2), onSave: this.savePayment, onHide: () => this.setState({ showLogPaymentModal: false }) })),
            this.state.showCreditMemoModal && (React.createElement(CreditMemoModal, { selectedLineItem: this.getSelectedLineItem(this.state.invoice), showModal: this.state.showCreditMemoModal, shipment: this.state.shipment, onClose: () => this.setState({ showCreditMemoModal: false }), disableSave: this.state.disableSaveCreditMemoButton, onSave: (data) => this.handleSaveCreditMemo(data) })),
            React.createElement(SendEmailModal, { show: this.state.showSendEmailModal, onSend: this.sendEmail, onHide: () => this.setState({ showSendEmailModal: false }) }),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-d648aa58", show: this.state.showLineItemConfirmModal, title: title, message: message, onConfirm: onConfirm, onHide: () => this.setState({ showLineItemConfirmModal: false }) })));
    }
    renderInvoiceV2() {
        var _a, _b, _c;
        const { t } = this.props;
        const { invoice, isAdmin, invoiceErrors, disableCreditMemoOption } = this.state;
        const { title, message, onConfirm } = this.state.confirmModal;
        const showInvoiceErrors = invoiceErrors && !_.isEmpty(invoiceErrors);
        const selectedValue = this.defineDropdownSelectedValue();
        return (React.createElement("div", { "data-testid": "div-f104d4f9", className: "mx-auto max-w-7xl space-y-6 p-4 sm:p-6 lg:p-8" },
            showInvoiceErrors && (React.createElement(Alert, { dataTestId: "Alert-4eedc2d6", type: "warning", title: invoiceErrors.title },
                React.createElement("div", { "data-testid": "div-57ba8b68" }, invoiceErrors.body))),
            React.createElement(InvoiceHeader, { invoice: invoice, invoiceId: this.state.invoiceId, isAdmin: isAdmin, isModal: !!this.props.invoiceId, canGenerateCreditMemo: this.state.canGenerateCreditMemo, disableCreditMemoOption: disableCreditMemoOption, onOpenCreditMemoModal: this.openCreditMemoModal, onRegenerateInvoice: this.regenerateInvoice, regenerating: this.state.regenerating }),
            React.createElement(Card, null,
                React.createElement(Tabs, { defaultValue: "jobs", className: "w-full", onValueChange: (value) => this.setState({ activeTab: value }) },
                    React.createElement(CardHeader, { className: "pb-3" },
                        React.createElement(TabsList, { className: "justify-start" },
                            React.createElement(TabsTrigger, { value: "jobs" }, t('LINE_ITEMS')),
                            this.isDebitInvoiceType() && (React.createElement(TabsTrigger, { value: "payments" }, t('PAYMENTS'))),
                            React.createElement(TabsTrigger, { value: "audit" }, t('AUDIT_HISTORY')),
                            (invoice === null || invoice === void 0 ? void 0 : invoice.invoice_type) !== 'credit' &&
                                ((_a = invoice === null || invoice === void 0 ? void 0 : invoice.credit_memos) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(TabsTrigger, { value: "credit-memos" }, t('CREDIT_MEMO'))))),
                    React.createElement(TabsContent, { value: "jobs", className: "mt-0" },
                        React.createElement(CardContent, null,
                            React.createElement(InvoiceARTable, { invoiceId: this.state.invoiceId }))),
                    this.isDebitInvoiceType() && (React.createElement(TabsContent, { value: "payments", className: "mt-0" },
                        React.createElement(CardContent, { className: "space-y-4" },
                            React.createElement("div", { className: "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" },
                                React.createElement("h3", { className: "text-base font-semibold my-0" }, "Payment History"),
                                React.createElement("div", { className: "flex flex-wrap items-center gap-3" },
                                    isAdmin && (React.createElement(PaymentMethodDialog, { open: this.state.showPaymentMethodDialog, onOpenChange: (open) => {
                                            this.setState(Object.assign({ showPaymentMethodDialog: open }, (open
                                                ? { tempPaymentMethod: selectedValue }
                                                : {})));
                                        }, selectedValue: selectedValue, tempValue: this.state.tempPaymentMethod, onTempValueChange: (value) => this.setState({ tempPaymentMethod: value }), onSave: this.handleSavePaymentMethod, isSaving: this.state.isSavingPaymentMethod, disabled: !this.state.hasFinanceAdminRole, label: this.getPaymentMethodLabel(), description: t('PAYMENT_METHOD_TOOLTIP_MESSAGE') })),
                                    isAdmin && (React.createElement(Button, { size: "sm", className: "bg-zinc-900 text-white hover:bg-zinc-800 gap-2", "data-testid": "button-17f95155", onClick: () => this.setState({ showLogPaymentModal: true }) },
                                        React.createElement(DollarSign, { className: "h-4 w-4" }),
                                        t('RECORD_PAYMENT'))))),
                            React.createElement(PaymentHistory, { payments: ((_b = invoice.payments) === null || _b === void 0 ? void 0 : _b.filter((payment) => payment.type === 'payment')) || [], currency: invoice === null || invoice === void 0 ? void 0 : invoice.currency })))),
                    React.createElement(TabsContent, { value: "audit", className: "mt-0" },
                        React.createElement(CardContent, null,
                            React.createElement(HistoryTable, { data: invoice.audit || [], type: "Invoice" }))),
                    (invoice === null || invoice === void 0 ? void 0 : invoice.invoice_type) !== 'credit' &&
                        ((_c = invoice === null || invoice === void 0 ? void 0 : invoice.credit_memos) === null || _c === void 0 ? void 0 : _c.length) > 0 && (React.createElement(TabsContent, { value: "credit-memos", className: "mt-0" },
                        React.createElement(CardContent, null,
                            React.createElement(CreditMemoTable, { creditMemoList: invoice === null || invoice === void 0 ? void 0 : invoice.credit_memos })))))),
            React.createElement(DataPoller, { dataTestId: "DataPoller-32de1597", frequency: 60000, action: () => this.onChange() }),
            this.state.showLogPaymentModal && (React.createElement(LogPaymentModal, { show: this.state.showLogPaymentModal, amount: (this.state.balance || 0).toFixed(2), onSave: this.savePayment, onHide: () => this.setState({ showLogPaymentModal: false }) })),
            this.state.showCreditMemoModal && (React.createElement(CreditMemoModal, { selectedLineItem: this.getSelectedLineItem(this.state.invoice), showModal: this.state.showCreditMemoModal, shipment: this.state.shipment, onClose: () => this.setState({ showCreditMemoModal: false }), disableSave: this.state.disableSaveCreditMemoButton, onSave: (data) => this.handleSaveCreditMemo(data) })),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-d648aa58", show: this.state.showLineItemConfirmModal, title: title, message: message, onConfirm: onConfirm, onHide: () => this.setState({ showLineItemConfirmModal: false }) })));
    }
    renderInvoice() {
        var _a;
        const order = (_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.order;
        if (isLegManagementEnabled(order)) {
            return this.renderInvoiceV2();
        }
        return this.renderInvoiceV1();
    }
    render() {
        if (this.state.loading) {
            return React.createElement(Loading, null);
        }
        return this.renderInvoice();
    }
}
InvoiceDetails.propTypes = {
    match: PropTypes.object.isRequired,
    invoiceId: PropTypes.string,
};
export default withTranslation()(InvoiceDetails);
